import React from "react";
import { Link } from "react-router-dom";

const BACKEND = process.env.REACT_APP_BACKEND_URL;
const img = (p) => `${BACKEND}${p}`;

const Hero = () => {
  return (
    <section className="relative overflow-hidden bg-[var(--ivory)] vc-grain" data-testid="hero-section">
      {/* Vertical side meta — editorial signature */}
      <div className="hidden lg:flex absolute left-6 top-1/2 -translate-y-1/2 z-10 flex-col items-center gap-4">
        <span className="vc-vertical-meta">Venus 3D Creations — Studio Collection N°03</span>
        <span className="w-px h-24 bg-[var(--copper)]/50" aria-hidden="true" />
      </div>

      <div className="relative max-w-[1440px] mx-auto px-6 lg:px-20 pt-24 lg:pt-32 pb-24 lg:pb-40 z-[2]">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-16 items-end">
          {/* Copy column */}
          <div className="lg:col-span-6 lg:pr-6">
            <p className="vc-eyebrow text-[var(--espresso)]/80 vc-fade-up mb-10" data-testid="hero-eyebrow">
              Studio Collection 2026
            </p>
            <h1
              className="font-serif-display font-light text-[52px] md:text-[72px] lg:text-[92px] leading-[0.98] text-[var(--espresso)] vc-fade-up vc-stagger-1"
              data-testid="hero-heading"
            >
              Objects printed
              <br />
              like they were
              <br />
              <em className="italic text-[var(--copper)]">sculpted</em>
              <span className="text-[var(--copper)]/80">.</span>
            </h1>

            <div className="mt-12 flex items-start gap-6 vc-fade-up vc-stagger-2">
              <span className="font-serif-display italic text-[var(--copper)] text-3xl leading-none mt-1">—</span>
              <p className="text-base md:text-lg text-[var(--espresso)]/70 max-w-md leading-[1.9] tracking-wide">
                A studio for lamps and objects that blend imagination with technology — designed to bring warmth, character and quiet art into everyday spaces.
              </p>
            </div>

            <div className="mt-14 flex flex-wrap items-center gap-8 vc-fade-up vc-stagger-3">
              <Link
                to="/shop"
                className="vc-btn-ghost inline-flex items-center h-12 px-10 text-[11px] tracking-[0.28em] uppercase"
                data-testid="hero-cta-shop"
              >
                Explore the collection
              </Link>
              <Link
                to="/contact"
                className="text-[11px] tracking-[0.28em] uppercase text-[var(--espresso)]/70 vc-link-underline"
                data-testid="hero-cta-commission"
              >
                Commission a piece
              </Link>
            </div>

            {/* Editorial meta row */}
            <div className="mt-20 pt-8 border-t border-[var(--hairline)] grid grid-cols-3 gap-6 max-w-lg vc-fade-up vc-stagger-4">
              <div>
                <p className="font-serif-display italic text-[var(--copper)] text-xl leading-none">01</p>
                <p className="text-[10px] tracking-[0.3em] uppercase text-[var(--espresso)]/55 mt-3">Handcrafted</p>
              </div>
              <div>
                <p className="font-serif-display italic text-[var(--copper)] text-xl leading-none">02</p>
                <p className="text-[10px] tracking-[0.3em] uppercase text-[var(--espresso)]/55 mt-3">Made in India</p>
              </div>
              <div>
                <p className="font-serif-display italic text-[var(--copper)] text-xl leading-none">03</p>
                <p className="text-[10px] tracking-[0.3em] uppercase text-[var(--espresso)]/55 mt-3">Limited run</p>
              </div>
            </div>
          </div>

          {/* Image column with layered secondary image */}
          <div className="lg:col-span-6 relative vc-copper-halo">
            <div className="relative z-[1] vc-fade-in">
              <div className="aspect-[4/5] overflow-hidden bg-[var(--sand)] vc-img-zoom">
                <img
                  src={img("/api/static/products/nova-01.webp")}
                  srcSet={`${img("/api/static/products/nova-01-480.webp")} 480w, ${img("/api/static/products/nova-01.webp")} 1050w`}
                  sizes="(min-width: 1024px) 50vw, 100vw"
                  alt="Nova Lamp — signature sculptural lighting"
                  fetchPriority="high"
                  decoding="async"
                  className="w-full h-full object-cover vc-image-reveal"
                />
              </div>

              {/* Caption badge */}
              <div className="hidden lg:flex absolute -right-4 top-10 flex-col items-end gap-3 vc-fade-in vc-stagger-4">
                <span className="font-serif-display italic text-[var(--copper)] text-5xl leading-none">N°01</span>
                <span className="text-[10px] tracking-[0.35em] uppercase text-[var(--espresso)]/60">Nova — Sculpted light</span>
              </div>
            </div>
          </div>
        </div>

        {/* Scroll hint */}
        <div className="hidden lg:flex absolute right-10 bottom-10 items-center gap-3 vc-fade-in vc-stagger-5" aria-hidden="true">
          <span className="text-[10px] tracking-[0.35em] uppercase text-[var(--espresso)]/55">Scroll</span>
          <span className="w-10 h-px bg-[var(--copper)]" />
        </div>
      </div>
    </section>
  );
};

export default Hero;
